import { useCardApi } from "../api/CardApiClient";
import { CardFrontendService } from "../services/CardFrontendService";

export const useCardService = (): CardFrontendService =>
  new CardFrontendService(useCardApi());
